import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    successMessage: null,
    errorMessage: null,
    userDetailList: {}
}

export const profileInfoSlice = createSlice({
    name: 'profile', initialState,
    reducers: {
        setInitalState: (state, action) => {
            state.successMessage = null;
            state.errorMessage = null;
        },
        getEmployerUserDetailSuccess: (state, action) => {
            state.userDetailList = action.payload;
            state.errorMessage = null;
        },
        getEmployerUserDetailError: (state, action) => {
            state.userDetailList = {};
            state.errorMessage = action.payload;
        },
        updateProfileInfoSuccess: (state, action) => {
            state.successMessage = action.payload;
            state.errorMessage = null;
        },
        updateProfileInfoError: (state, action) => {
            state.successMessage = null;
            state.errorMessage = action.payload;
        },
    }
});
export const {
    setInitalState,
    getEmployerUserDetailSuccess,
    getEmployerUserDetailError,
    updateProfileInfoSuccess,
    updateProfileInfoError
} = profileInfoSlice.actions;

export default profileInfoSlice.reducer;